import { render, staticRenderFns } from "./ProjectReportCard.component.vue?vue&type=template&id=386f2065&scoped=true&"
import script from "./ProjectReportCard.component.vue?vue&type=script&lang=ts&"
export * from "./ProjectReportCard.component.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectReportCard.component.vue?vue&type=style&index=0&id=386f2065&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f2065",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDivider,VIcon})
